import type { UserBasicInfo } from '@erp/rpc';

export function findAssigneeUser(
  value: string | null | undefined,
  users: UserBasicInfo[] | undefined,
): UserBasicInfo | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }
  return users?.find((user) => user.id === value);
}

export function shouldLookupAssigneeName(
  value: string | null | undefined,
  assignees: UserBasicInfo[] | undefined,
): value is string {
  return (
    typeof value === 'string' &&
    assignees !== undefined &&
    findAssigneeUser(value, assignees) === undefined
  );
}

export function assigneeTriggerLabel({
  selectedName,
  value,
  placeholder,
  unassignedLabel,
  unresolvedLabel,
}: {
  selectedName: string | undefined;
  value: string | null | undefined;
  placeholder: string | undefined;
  unassignedLabel: string;
  unresolvedLabel: string;
}): string {
  if (selectedName !== undefined) {
    return selectedName;
  }
  if (typeof value === 'string') {
    return unresolvedLabel;
  }
  if (value === undefined && placeholder !== undefined) {
    return placeholder;
  }
  return unassignedLabel;
}
